/**
 * The /health-horoscope/ "which rashi is yours?" check's own props.
 * Everything the reader sees of the form (its words, its frame, its field ids
 * and its no-time explainer) is the /rashi/<sign>/ check's
 * (components/rashi/rashi-check-form.ts), imported unchanged; only the
 * analytics placement, the slot's room and the answer's next step belong to
 * this page.
 */

/** free_tool_started and calculator_used placement for this page's check. */
export const HEALTH_RASHI_CHECK_PLACEMENT = "health_horoscope_page_check";

/**
 * The slot's floor, from the server HTML: the tallest measured state, which
 * every state fills (HealthRashiCheckLazy has the numbers).
 */
export const HEALTH_RASHI_CHECK_RESERVE = "min-h-[600px] sm:min-h-[500px]";

/**
 * A sign's yearly Rashifal, the page this hub's 12-sign grid opens for each
 * sign (lib/listing-collections.ts): its forecast has a health section for the
 * year. This page writes no health prediction of its own.
 */
export function yearlyHealthHref(rashi: string): string {
  return `/yearly-rashifal/${rashi}/`;
}
